var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-policy-manage',{ref:"table",staticClass:"pt-policy-manage__withData",on:{"deletePolicy":_vm.deletePolicy}})}
var staticRenderFns = []

export { render, staticRenderFns }